require('./lib/qtip2/jquery.qtip.css');
require('./lib/angularjs-slider/dist/rzslider.css');

require('openlayers/dist/ol.css');

require('./lib/bootstrap-custom.css');

require('./css/jquery-ui-1.8.6/smoothness/jquery.ui.core.css');
require('./css/jquery-ui-1.8.6/smoothness/jquery.ui.button.css');
require('./css/jquery-ui-1.8.6/smoothness/jquery.ui.datepicker.css');
require('./lib/validationEngine/validationEngine.jquery.css');
require('./lib/griddle/griddle.css');

require('fullcalendar/dist/fullcalendar.css');
require('font-awesome/css/font-awesome.min.css');
require('./lib/jqwidgets/styles/jqx.base.css');

require('./css/jquery-ui-1.8.6/cfn365/jquery.ui.theme.css');
require('./app/directives/cfnSpinner.css');
require('./app/common/directives/table.style.css');
require('./css/genStyles.css');
require('./css/app-responsive.global.pcss');
require('./css/pageTitle.css');
require('./app/directives/cfnGrid/grid.css');
require('./app/directives/input/autocomplete.directive.css');
require('./app/directives/input/btn-toggle.directive.css');
require('./css/grid-fip.css');
require('./css/claas.css');
require('./css/farmnet-font.css');
require('./css/roboto.css');
require('./css/design-responsive.global.pcss');
require('./css/responsive.css');
require('./app/directives/appIcon/appIcon.global.pcss');
require('./app/login/registration/selfRegistration.css');
require('./app/admin/settings/settings.css');
require('./app/admin/settings/company/companySettings.css');
require('./app/admin/settings/external/plant/settingsPlant.css');
require('./app/termsAcceptance/termsAcceptance.css');
require('./app/booking/ownActivities/ownActivitiesIcons.css');
require('./app/booking/bookingDate/bookingDate.css');
require('./app/booking/bookingIndex.css');
require('./app/booking/bookingList.css');
require('./app/booking/bookingMask.css');
require('./app/core/wizards/bookingImportWizard.css');
require('./app/core/assets/fieldCore.css');
require('./app/core/wizards/fieldImportWizard.css');
require('./app/core/supplies/fertilizerCore.css');
require('./app/core/supplies/plantProtectantCore.css');
require('./app/core/supplies/seedCore.css');
require('./app/admin/settings/user/user.css');
require('./app/login/login.css');
require('./app/dashboard/dashboard.global.pcss');
require('./app/partner/amazone/amazoneMachineSettingsDirective.css');
require('./app/planning/cropPlanning/cropPlanningOperation.css');
require('./app/planning/cropSequencePlanning/cropSequencePlanning.css');
require('./app/planning/cropSequencePlanning/cropsequence.css');
require('./app/planning/seedPlanning/seedPlanning.css');
require('./app/modules/farmnet/partner.externalAccounts/ui/SettingsExternalAccount.css');
require('./app/modules/farmnet/partner.fendt/ui/FendtVarioDocButton.css');
require('./app/common/geo/geo.css');
require('./css/container.global.pcss');
require('./css/masterdata-view.global.pcss');
require('./css/calendar.css');
require('./css/landing.css');
require('./css/tabbed-table.style.css');
require('./css/button-icon.style.css');
require('./app/common/directives/d-page-button-dropdown/d-page-button-dropdown.style.css');
require('./app/common/directives/d-tabs/d-tabs.css');
require('./app/booking/templates/cfnBookingElement.css');
require('./app/booking/templates/fieldTable.css');
require('./app/booking/templates/fruitTable.css');
require('./app/booking/templates/machineTable.css');
require('./app/booking/templates/supplyTableSupplies.css');
require('./app/booking/templates/cfnBookingSupply.css');
require('./app/booking/templates/sysCultureTable.css');
require('./app/booking/templates/seedTable.css');
require('./app/common/loadingBroadcastHint/loadingBroadcastHint.global.pcss');
require('./app/planning/cropSequencePlanning/components/greening/ecologicalFocusArea/ecologicalFocusArea.css');
require('./app/planning/planningModule.style.css');
require('./app/common/components/email-change-confirm-popup/email-change-confirm-popup.css');
require('@farmnet/components/dist/farmnet-components.css');

import './app/browsercheck.js';

import './polyfills.js';
import './monolith-vendor.js';
import './monolith-jsfiles.js';

import './monolith-angular.ts';
